import { Typography } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { ModalWrapper } from 'src/components/modal-wrapper'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  values: object | null
  handleClose: () => void
}

export const ResponseForm = ({ values, open, handleClose }: IProps) => {
  const classes = useStyles()

  if (!values) return null

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div>
        <Typography className={classes.title}>
          <HelperWrapper t="response-form-title" />
        </Typography>
      </div>
      <pre className={classes.responseWrapper}>{JSON.stringify(values, null, 2)}</pre>
    </ModalWrapper>
  )
}
